import { ChatMessage, DisplayChatMessage } from 'interfaces/UserChat'
import { minutesBetweenDates, formatDateTime } from 'lib/formatting/datetime'
import { Overline } from 'stories/elements/Typography/Text'

export const showMessageTimeStamp = (message: DisplayChatMessage, currentIndex: number, allMessages: DisplayChatMessage[]) =>
    (message?.createdOn &&
        allMessages[currentIndex - 1] &&
        minutesBetweenDates(allMessages[currentIndex - 1].createdOn, message.createdOn) > 10) ||
    allMessages[currentIndex + 1]?.userIdentification !== message.userIdentification ? (
        <Overline fontFamily="var(--font-inter)" fontWeight={400} className="timestamp">
            {formatDateTime(message.createdOn, true)}
        </Overline>
    ) : null

const generateDisplayMessage = (chatMessage: ChatMessage): DisplayChatMessage => ({
    uuid: chatMessage.uuid,
    message: chatMessage.message,
    createdOn: chatMessage.createdOn,
    userIdentification: chatMessage.user.uuid,
    attachmentUrl: chatMessage.attachmentUrl,
    know: chatMessage.know,
    allowLinks: chatMessage.allowLinks,
    threadMessageCount: chatMessage.threadMessageCount,
    chatUuid: chatMessage.chatUuid,
    voiceMessagePath: chatMessage.voiceMessagePath,
})

export const generateDisplayMessages = (messages: ChatMessage[]): DisplayChatMessage[] =>
    messages.map((chatMessage) => generateDisplayMessage(chatMessage))
